/**
 * OrDivider — "또는" 라벨이 가운데 들어간 구분선.
 * ui-core `Divider`(§15.14)는 라벨 슬롯이 없어 그대로 쓸 수 없다.
 * 로그인·회원가입 진입 화면이 같은 간격을 갖도록 여백까지 이 컴포넌트가 소유한다.
 */
export function OrDivider({ label = '또는' }: { label?: string }) {
  return (
    <div className="my-06 flex items-center gap-md">
      <div className="h-px flex-1 bg-border" />
      <span className="whitespace-nowrap text-caption text-text-disabled">{label}</span>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
}
